import styled from 'styled-components';
import Link from 'next/link';
import { Breakpoints } from '../../../styled/constants';
import { FlexColumn, FlexibleDiv } from '../../../styled/common';
import { tagStyles } from '../../ui/Typography/styles';

export const ApartmentTypesContainer = styled(FlexibleDiv)`
  display: none;

  @media (min-width: ${Breakpoints.desktop}px) {
    display: flex;
    align-items: center;
    background: linear-gradient(100deg, #e7e7e7 100%);
    border-radius: 14px;
    height: 90px;
    padding: 0 40px;
    margin: 30px 0;
    gap: 71px;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    & > * {
      flex: 0 0 auto;
    }

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ApartmentItem = styled(FlexColumn)`
  gap: 5px;
`;

export const ApartmentItemValue = styled(Link)`
  white-space: nowrap;
  ${tagStyles.h5_new};

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`;
